'use client';

import { useState } from 'react';
import { useEventListener } from '../useEventListener/useEventListener';
import { useIsomorphicLayoutEffect } from '../useIsomorphicLayoutEffect/useIsomorphicLayoutEffect';

type Scroll = {
  left: number;
  top: number;
};

export function useScroll(): Scroll {
  const [scroll, setScroll] = useState<Scroll>({ left: 0, top: 0 });

  const onScroll = () => {
    const left = window.scrollX;
    const top = window.scrollY;
    if (scroll.left !== left || scroll.top !== top) {
      setScroll({ left, top });
    }
  };

  useEventListener('scroll', onScroll);

  // Set size at the first client-side load
  useIsomorphicLayoutEffect(() => {
    onScroll();

  }, []);

  return scroll;
}
